import React from 'react'
import styled from 'styled-components'

const Svg = styled.svg`
  path {
    transition: all 800ms;
  }
`

export default ({ color1, color2 }) => (
  <Svg width="57" height="65" viewBox="0 0 57 65" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M28.255 56.51c-8.775 0-15.914-7.212-15.914-16.076V27.93h1.474v12.504c0 8.043 6.478 14.587 14.44 14.587s14.44-6.544 14.44-14.587v-.744h1.474v.744c0 8.864-7.139 16.076-15.914 16.076"
        fill={color1 || '#fff'} />
      <path fill={color1 || '#fff'} d="M12.748 36.374l-6.902-4.871 6.902-4.872.892 1.194-5.21 3.678 5.21 3.677zM28.58 60.407h1.299v-5.846h-1.3z"
      />
      <path d="M27.28 35.725h-1.464v-8.09c0-3.324-2.694-6.029-6.005-6.029s-6.005 2.705-6.005 6.03v.736h-1.465v-.736c0-4.136 3.351-7.5 7.47-7.5s7.47 3.364 7.47 7.5v8.089zM27.994 50.664h-.741v-1.48h.741c4.986 0 9.086-3.853 9.466-8.732H23.383v-1.48h15.59v.74c0 6.04-4.925 10.952-10.979 10.952"
        fill={color1 || '#fff'} />
      <path d="M19.486 27.93a1.299 1.299 0 1 1-2.598 0 1.299 1.299 0 0 1 2.598 0M44.169 36.374h-1.477v-.769c0-1.951-1.523-3.538-3.395-3.538s-3.395 1.587-3.395 3.538v.77h-1.476v-.77c0-2.8 2.185-5.077 4.871-5.077 2.686 0 4.872 2.278 4.872 5.077v.77zM25.332 19.486h-.753c-1.44 0-2.181-.799-2.775-1.44-.567-.612-.924-.958-1.668-.958-.745 0-1.101.346-1.668.957-.595.642-1.335 1.441-2.775 1.441h-.754v-1.499h.754c.744 0 1.1-.346 1.667-.957.595-.642 1.335-1.441 2.776-1.441 1.44 0 2.18.799 2.775 1.44.566.612.923.958 1.668.958h.753v1.5z"
        fill={color1 || '#fff'} />
      <path d="M40.879 0c-6.44 0-11.68 5.206-11.68 11.606 0 6.4 5.24 11.607 11.68 11.607 6.19 0 11.268-4.811 11.653-10.868h2.49v51.131H1.488v-6.502H0v7.98h56.51V10.867h-3.978C52.147 4.811 47.07 0 40.88 0m0 21.735c-5.62 0-10.193-4.544-10.193-10.129S35.258 1.478 40.88 1.478c5.62 0 10.192 4.543 10.192 10.128s-4.572 10.129-10.192 10.129"
        fill={color2 || '#fff'} />
      <path d="M40.673 9.094c-1.213 0-2.196 1-2.196 2.236 0 .378.093.735.256 1.047l-4.307 4.797 1.089 1.013 4.306-4.796c.262.113.55.175.852.175 1.213 0 2.197-1.001 2.197-2.236 0-1.235-.984-2.236-2.197-2.236"
        fill={color2 || '#fff'} />
    </g>
  </Svg>
);


// WEBPACK FOOTER //
// ./src/ui/components/generic/IconProduction.js